/**
 * @generated SignedSource<<6db4d77565a5b40057ecdea676305fb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarEvent_teamScheduleOneOffEvent$data = {
  readonly description: string | null;
  readonly endAtFormatted: string | null;
  readonly id: string;
  readonly startAt: string;
  readonly startAtFormatted: string;
  readonly title: string;
  readonly " $fragmentType": "WidgetCalendarEvent_teamScheduleOneOffEvent";
};
export type WidgetCalendarEvent_teamScheduleOneOffEvent$key = {
  readonly " $data"?: WidgetCalendarEvent_teamScheduleOneOffEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarEvent_teamScheduleOneOffEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetCalendarEvent_teamScheduleOneOffEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAtFormatted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAtFormatted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "TeamScheduleOneOffEvent",
  "abstractKey": null
};

(node as any).hash = "9a46520de8710d8c7235804ad0ce1d0d";

export default node;
